import { render, staticRenderFns } from "./UserAuthList.vue?vue&type=template&id=1fafa21e&"
import script from "./UserAuthList.vue?vue&type=script&lang=js&"
export * from "./UserAuthList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports